var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.2002 7.99999C3.2002 6.23268 4.63288 4.79999 6.4002 4.79999H25.6002C27.3675 4.79999 28.8002 6.23268 28.8002 7.99999V19.2C28.8002 20.9673 27.3675 22.4 25.6002 22.4H6.4002C4.63288 22.4 3.2002 20.9673 3.2002 19.2V7.99999Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 22.4V25.6M11.2002 27.2H20.8002M6.4002 22.4H25.6002C27.3675 22.4 28.8002 20.9673 28.8002 19.2V7.99999C28.8002 6.23268 27.3675 4.79999 25.6002 4.79999H6.4002C4.63288 4.79999 3.2002 6.23268 3.2002 7.99999V19.2C3.2002 20.9673 4.63288 22.4 6.4002 22.4Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemon);
export default __webpack_public_path__ + "static/media/systemon.3bf2fa62929fe5c73b95bf99b74273ad.svg";
export { ForwardRef as ReactComponent };